import { jsxs as r, jsx as a } from "react/jsx-runtime";
const l = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M27 19.741a2.5 2.5 0 0 1-2.497-2.497A2.5 2.5 0 0 1 27 14.747a2.5 2.5 0 0 1 2.497 2.497A2.5 2.5 0 0 1 27 19.741ZM36.994 19.741a2.5 2.5 0 0 1-2.497-2.497 2.5 2.5 0 0 1 2.497-2.497 2.5 2.5 0 0 1 2.497 2.497 2.5 2.5 0 0 1-2.497 2.497ZM42.731 28.693a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM32.024 28.693a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM21.317 28.693a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM39.991 49.98a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996Zm0-5.227a1.233 1.233 0 0 0 0 2.464 1.233 1.233 0 0 0 0-2.464ZM24.008 50.245a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996Zm-.002-5.227a1.233 1.233 0 0 0 0 2.464 1.233 1.233 0 0 0 0-2.464ZM37.395 37.042a4 4 0 0 1-3.995-3.996 4 4 0 0 1 3.995-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996ZM26.589 37.042a4 4 0 0 1-3.996-3.996 4 4 0 0 1 3.996-3.996 4 4 0 0 1 3.996 3.996 4 4 0 0 1-3.996 3.996Z"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          d: "M42.67 10.188c4.765 3.351 7.878 8.891 7.878 15.159a18.468 18.468 0 0 1-5.867 13.522 8.059 8.059 0 0 1-3.786 15.174H23.16a8.059 8.059 0 0 1-3.786-15.174 18.467 18.467 0 0 1-5.866-13.522c0-6.268 3.114-11.808 7.877-15.159H42.67Zm1.264-3.996H20.119l-1.034.727a22.695 22.695 0 0 0-6.955 7.88 22.567 22.567 0 0 0-2.619 10.547c0 3.17.647 6.235 1.922 9.114a22.372 22.372 0 0 0 2.295 4.011 12.036 12.036 0 0 0-2.623 7.513c0 3.219 1.254 6.247 3.531 8.524a11.978 11.978 0 0 0 8.524 3.531h17.735c3.22 0 6.247-1.254 8.524-3.531a11.98 11.98 0 0 0 3.531-8.524c0-2.783-.952-5.415-2.623-7.513a22.442 22.442 0 0 0 2.295-4.011 22.342 22.342 0 0 0 1.922-9.114 22.57 22.57 0 0 0-2.619-10.547 22.689 22.689 0 0 0-6.956-7.88l-1.034-.727h-.001Z"
        }
      )
    ]
  }
);
export {
  l as ChargerCssCombo
};
